import { handleClasses } from './responsive/responsive';

export default (element: HTMLElement, componentId: string) => {
    let size: number = element.getBoundingClientRect().width
    let running: boolean = false

    const abortController = new AbortController();

    const resizeObserver = new ResizeObserver(entries => {
        entries.forEach(entry => {
            if (running || size === entry.contentRect.width || entry.contentRect.width <= 0) return;

            size = entry.contentRect.width

            running = true

            handle(element)

            running = false
        });
    });

    window.addEventListener('loading', ({ detail }: any) => {
        const { loading } = detail
        const id = detail.componentId

        if (loading || id !== componentId) {
            return;
        }

        setTimeout(() => {
            handle(element)
        }, 0)
    }, { signal: abortController.signal })

    resizeObserver.observe(element);

    handle(element)

    return {
        destroy() {
            abortController.abort();
            resizeObserver.disconnect();
        }
    };
}

function handle(element: HTMLElement) {
    const headers: NodeListOf<HTMLElement> = element.querySelectorAll('.flex-table-head .head-item')

    headers.forEach((header: HTMLElement) => {
        handleClasses(header, element.clientWidth)
    })

    /** Should be called after responsive to get the .hidden correctly */
    setLastChildClass(element.querySelector('.flex-table-head'), true)

    const rows: NodeListOf<HTMLElement> = element.querySelectorAll('.flex-table-row')

    rows.forEach((row: HTMLElement) => {
        const accordion = getAccordion(row)
        const rowItems: NodeListOf<HTMLElement> = row.querySelectorAll('.flex-table-item')

        accordion.cleanup()

        rowItems.forEach((element: HTMLElement, index: number) => {
            const item = getItem(element, index)

            item.initialize()

            if (item.contentHasEllipses() && !item.shouldHide()) {
                accordion.addRow(element, index)
            }

            if (item.shouldHide()) {
                item.hide()
                accordion.addRow(element, index)
            }
        })

        setLastChildClass(row)
    })

    function getItem(item: HTMLElement, index: number) {
        const width: number = parseFloat(headers[index].clientWidth.toFixed(2))

        return {
            initialize: (): void => {
                item.classList.remove('hidden')
                item.style.width = width + 'px'
                item.style.minWidth = width + 'px'
            },
            contentHasEllipses(): boolean {
                const elementWithLineClamp = item.querySelector('.line-clamp-2')

                if (!elementWithLineClamp) return false

                return elementWithLineClamp?.scrollHeight > elementWithLineClamp?.clientHeight
            },
            shouldHide: (): boolean => {
                return width === 0
            },
            hide: (): void => {
                item.classList.add('hidden')
            }
        }
    }

    function getAccordion(row: HTMLElement)  {
        const accordion: Element | null = row.querySelector('.flex-table-accordion')
        const accordionToggleButton: Element | null = row.querySelector('.accordion-toggle-button')

        return {
            cleanup: (): void => {
                if (!accordion) return

                if (accordion.parentElement?.childElementCount === 1) {
                    accordionToggleButton?.classList.add('hidden')
                }

                accordion.classList.add('hidden!')
                accordion.innerHTML = ''
            },
            addRow: (item: HTMLElement, index: number): void => {
                if (!accordion) return

                const title = headers[index].textContent?.trim();

                let content: string | undefined = ''

                if (item.querySelector('[data-responsive-accordion]')) {
                    content = item.querySelector('[data-responsive-accordion]')?.innerHTML
                } else {
                    content = item.firstElementChild?.innerHTML
                }

                accordion.classList.remove('hidden!')
                accordionToggleButton?.classList.remove('hidden')

                accordion.innerHTML += `
                    <div class="max-w-full flex flex-col items-start gap-2">
                        <div class='text-xs font-bold tracking-wider uppercase'>
                            ${title}
                        </div>

                        <div class="max-w-full">
                            ${content}
                        </div>
                    </div>
                `
            }
        }
    }

    function setLastChildClass(element: null | HTMLElement, isHeader: boolean = false) {
        if (!element) {
            return
        }

        element.querySelectorAll('.last-child').forEach(lastChild => {
            lastChild.classList.remove('last-child');
        });

        if (isHeader) {
            const items = element.querySelectorAll('.head-item:not(.hidden)');

            [].slice.call(items).pop().classList.add('last-child');
        } else {
            const items = element.querySelectorAll('.item:not(.hidden)');
    
            if (element.querySelectorAll('.actions.absolute').length && items.length) {
                [].slice.call(items).pop().classList.add('last-child');
            }
        }
    }
}
